/**
 * @deprecated please use @website/ui instead
 */
export * from "./popover-full";
/**
 * @deprecated please use @website/ui instead
 */
export * from "./popover-full.types";
